import { useAppI18N } from '@/app'
import { Button } from '@/components'
import { AnyFunction } from '@codeleap/types'

type Props = {
  strategy?: AnyFunction
}

export function ContinueButton(props: Props) {
  const { t } = useAppI18N()

  return (
    <Button
      variants={['fullWidth', 'minimal']}
      text={t('learn.components.doneModal.continueButton')}
      debugName={`Modal done continue`}
      onPress={props.strategy}
    />
  )
}
